import React, { PureComponent, Fragment } from 'react';
import { I18n } from 'aws-amplify';
import AppWrapperSimple from '../../components/AppWrapperSimple';
import { Link } from 'react-router-dom'

import PageSuccess from '../../components/PageSuccess';

class UserProfileSuccess extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        return (
            <AppWrapperSimple>
                <PageSuccess>
                    <Fragment>
                        <h2>{I18n.get("Obrigado pelo seu tempo!")}</h2>
                        <p>{I18n.get("Cadastro realizado com sucesso")}</p>
                        <p></p>
                        <br/>
                        <br/>
                        <p>{I18n.get("Para acessar a plataforma, basta se logar clicando")} <Link to="/login">{I18n.get("aqui")}</Link></p>
                    </Fragment>
                </PageSuccess>
            </AppWrapperSimple>
        );
    }
}

export default UserProfileSuccess;
